export default __webpack_public_path__ + "static/media/valleyPort7.c518e9be.png";